//find the currently set site from the provided set of sites.
export const getSelectedSite = sites => {
  const siteStorage = localStorage.getItem(`airfinder_selected_site`);

  return sites.find(function(site) {
    let p = site.hasOwnProperty('value') ? 'value' : 'id';
    return site[p] === siteStorage;
  });
};



// WEBPACK FOOTER //
// ./src/containers/adminusers/util.js